import React, { useRef, useState } from "react";
import {
    Button,
    TextField,
    Typography,
} from "@mui/material";
import LoginWrapper from "../../components/LoginWrapper";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";

function TwoFa() {


    const codeRef = useRef<HTMLInputElement>(null);

    const [code, setCode] = useState("");


    const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setCode(value);
    };


    const submitForm = () => {
        if (code === "") {
            codeRef.current?.focus();
            return;
        }
    };

  const lang:any = useBoundStore((state) => state.lang);


    return (
        <LoginWrapper showLogo={true}>
            <div className="content">
                <Typography variant="h6" textAlign={"center"}>
                    2-Faktor-Authentifizierung
                </Typography>

                <Typography variant="subtitle2" textAlign={"center"} sx={{ marginTop: 1 }}>
                    {i18n(lang)?.two_fector_desc}
                </Typography>
                <div className="form">
                    <TextField
                        id="outlined-basic"
                        label={i18n(lang)?.enter_code}
                        variant="outlined"
                        className="inputField"
                        onChange={handleCodeChange}
                        inputRef={codeRef}
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        sx={{ marginTop: 3,backgroundColor:"var(--primary-color)",letterSpacing:1.25 }}
                        onClick={submitForm}
                        className="lp125" 
                    >
                        {i18n(lang)?.check_code}
                    </Button>

                </div>
            </div>
        </LoginWrapper>
    );
}

export default TwoFa;
